import React, { useState } from 'react'
import LtsInputText from '../../../components/lottus/lts-input-text'
import LtsInputNumber from '../../../components/lottus/lts-input-number'
import LtsChips from '../../../components/lottus/lts-chips'
import { Button } from 'primereact/button'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import './ConfigRetornoCodigosConfiguracao.scss'

/**
 * Componente para editar códigos de liquidação
 * Estrutura: { "codigo": { descricao, codigos_relacionados: { posicoes: { inicio, fim }, valores: [] } } }
 *
 * @param {Object} props.value - Objeto com códigos de liquidação
 * @param {Function} props.onChange - Callback chamado quando o valor é alterado
 * @param {string} props.title - Título do campo (h5)
 * @param {string} props.error - Mensagem de erro de validação
 * @returns {JSX.Element}
 */
export default function ConfigRetornoCodigosConfiguracao(props) {
  const { value = {}, onChange, title, error, errors = {} } = props
  const messages = storage.getAppLabels('configuracaoboleto')
  const [novoCodigo, setNovoCodigo] = useState('')
  const [erroNovoCodigo, setErroNovoCodigo] = useState('')

  const handleCodigoChange = (codigo, field, newValue) => {
    const updatedValue = {
      ...value,
      [codigo]: {
        ...value[codigo],
        [field]: newValue,
      },
    }
    onChange?.(updatedValue)
  }

  const handleCodigosRelacionadosChange = (codigo, path, newValue) => {
    const updatedValue = {
      ...value,
      [codigo]: {
        ...value[codigo],
        codigos_relacionados: {
          ...value[codigo]?.codigos_relacionados,
        },
      },
    }

    if (path === 'posicoes.inicio') {
      updatedValue[codigo].codigos_relacionados.posicoes = {
        ...updatedValue[codigo].codigos_relacionados.posicoes,
        inicio: newValue,
      }
    } else if (path === 'posicoes.fim') {
      updatedValue[codigo].codigos_relacionados.posicoes = {
        ...updatedValue[codigo].codigos_relacionados.posicoes,
        fim: newValue,
      }
    } else if (path === 'valores') {
      updatedValue[codigo].codigos_relacionados.valores = newValue
    }

    onChange?.(updatedValue)
  }

  const addCodigo = () => {
    setErroNovoCodigo('')
    
    if (!novoCodigo || novoCodigo.trim() === '') {
      setErroNovoCodigo('Código é obrigatório')
      return
    }
    
    if (value[novoCodigo]) {
      setErroNovoCodigo('Código já existe')
      return
    }
    
    const updatedValue = {
      ...value,
      [novoCodigo]: {
        descricao: '',
        codigos_relacionados: {
          posicoes: {
            inicio: null,
            fim: null,
          },
          valores: [],
        },
      },
    }
    onChange?.(updatedValue)
    setNovoCodigo('')
  }

  const removeCodigo = (codigo) => {
    const updatedValue = { ...value }
    delete updatedValue[codigo]
    onChange?.(updatedValue)
  }

  return (
    <div className="config-retorno-codigos-configuracao">
      <div className="card card-w-title">
        <h5>{title}</h5>

        <div className="codigos-list">
          {Object.keys(value).map((codigo) => {
            const item = value[codigo]
            const itemErrors = errors?.[codigo] || {}
            const descricaoError = itemErrors.descricao
            const inicioError = itemErrors.codigos_relacionados?.posicoes?.inicio
            const fimError = itemErrors.codigos_relacionados?.posicoes?.fim
            const valoresError = itemErrors.codigos_relacionados?.valores
            return (
              <div key={codigo} className="card card-w-title codigo-item">
                <div className="codigo-header">
                  <h6>{utils.getMessage(messages, 'configuracaoboleto.label.configretorno.codigo')}: {codigo}</h6>
                  <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger p-button-text"
                    onClick={() => removeCodigo(codigo)}
                  />
                </div>

                <div className="p-grid form-group">
                  <div className="p-col-12">
                    <LtsInputText
                      label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.descricao')}
                      name={`descricao-${codigo}`}
                      value={item.descricao || ''}
                      onChange={(value) => handleCodigoChange(codigo, 'descricao', value)}
                      className={descricaoError ? 'p-invalid' : ''}
                    />
                    {descricaoError && <small className="p-error">{descricaoError}</small>}
                  </div>
                </div>

                <div className="card card-w-title">
                  <h6>{utils.getMessage(messages, 'configuracaoboleto.label.configretorno.codigosrelacionados')}</h6>
                  <div className="p-grid">
                    <div className="p-col-12 p-md-6">
                      <div className="card card-w-title">
                        <h6>{utils.getMessage(messages, 'configuracaoboleto.label.configretorno.posicoes')}</h6>
                        <div className="p-grid form-group">
                          <div className="p-col-12 p-md-6">
                            <LtsInputNumber
                              name={`inicio-${codigo}`}
                              label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.inicio')}
                              value={item.codigos_relacionados?.posicoes?.inicio ?? null}
                              onChange={(value) => handleCodigosRelacionadosChange(codigo, 'posicoes.inicio', value)}
                              className={inicioError ? 'p-invalid' : ''}
                            />
                            {inicioError && <small className="p-error">{inicioError}</small>}
                          </div>

                          <div className="p-col-12 p-md-6">
                            <LtsInputNumber
                              name={`fim-${codigo}`}
                              label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.fim')}
                              value={item.codigos_relacionados?.posicoes?.fim ?? null}
                              onChange={(value) => handleCodigosRelacionadosChange(codigo, 'posicoes.fim', value)}
                              className={fimError ? 'p-invalid' : ''}
                            />
                            {fimError && <small className="p-error">{fimError}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-col-12 p-md-6">
                      <div className="card card-w-title">
                        <h6>{utils.getMessage(messages, 'configuracaoboleto.label.configretorno.valores')}</h6>
                        <div className="p-grid form-group">
                          <div className="p-col-12">
                            <LtsChips
                              label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.valores')}
                              name={`valores-${codigo}`}
                              value={item.codigos_relacionados?.valores || []}
                              onChange={(value) => handleCodigosRelacionadosChange(codigo, 'valores', value)}
                              separator=","
                              className={valoresError ? 'p-invalid' : ''}
                            />
                            {valoresError && <small className="p-error">{valoresError}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        <div className="add-codigo-section">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-8 input-wrapper">
              <LtsInputText
                label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.codigo')}
                name="novo-codigo"
                value={novoCodigo}
                onChange={(value) => setNovoCodigo(value)}
                className={erroNovoCodigo ? 'p-invalid' : ''}
              />
              {erroNovoCodigo && <small className="p-error">{erroNovoCodigo}</small>}
            </div>
            <div className="p-col-12 p-md-4 button-wrapper">
              <Button
                label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.adicionarcodigo')}
                icon="pi pi-plus"
                onClick={addCodigo}
                className="p-button-success"
              />
            </div>
          </div>
        </div>

        {error && <small className="p-error">{error}</small>}
      </div>
    </div>
  )
}
